module.exports = __webpack_public_path__ + "img/11st_thai.dc4bcb6a.png";